export const common = {
  expired: "有効期限が切れました",
  sex: {
    female: "女性",
    male: "男性",
  },
};
